module.exports = __webpack_public_path__ + "static/media/11-mob.32088f15.webp";